const STORE_KEY = 'NEWS'

export const FETCH_NEWS = `${STORE_KEY}/FETCH_NEWS`
